import { AdminUserDetailComponent } from './../../components/admin-user-detail/admin-user-detail.component';
import { UserAdminService } from './../../services/user-admin.service';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';

import { UserAdminDataSource } from './../../datasources/user-admin-data-source';
import { SelectionModel } from '@angular/cdk/collections';
import { UsrInfo } from './../../models/usr-info.model';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';
import { AdminUserCreateComponent } from '../admin-user-create/admin-user-create.component';

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss']
})
export class AdminUsersComponent implements OnInit, AfterViewInit {
  dataSource: UserAdminDataSource;
  displayedColumns = ['email', 'status', 'updatedBy', 'updated', 'actions'];

  selection = new SelectionModel<UsrInfo>(true, []);
  viewOnlyActive = true;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private userAdminService: UserAdminService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.dataSource = new UserAdminDataSource(this.userAdminService);
    this.dataSource.loadUsers();
  }
  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.loadUsers();
    });
    this.paginator.page.pipe(tap(() => this.loadUsers())).subscribe();
  }

  loadUsers() {
    this.dataSource.loadUsers(
      this.paginator.pageIndex + 1,
      this.paginator.pageSize,
      (this.sort.direction === 'desc' ? '-' : '') + this.sort.active,
      this.viewOnlyActive
    );
  }

  changeOnlyActive() {
    this.viewOnlyActive = !this.viewOnlyActive;
    this.loadUsers();
  }

  deleteUser(user: UsrInfo) {
    user.status = 'D';
  }

  restoreUser(user: UsrInfo) {
    user.status = 'A';
  }

  openDetailDialog(user: UsrInfo): void {
    const dialogRef = this.dialog.open(AdminUserDetailComponent, {
      width: '700px',
      data: { userInfo: user },
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadUsers();
    });
  }

  openCreateDialog(): void {
    const dialogRef = this.dialog.open(AdminUserCreateComponent, {
      width: '700px',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(result => {
      this.loadUsers();
    });
  }

  toggleUserStatus(user: UsrInfo) {
    if (user.status === 'A') {
      user.status = 'D';
    } else {
      user.status = 'A';
    }
    this.userAdminService.updateUserInfo(user.email, user.status, user.userName, user.city, user.office).subscribe();
  }
}
